/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-29 10:22:56
 * @ Modified by: Daniel Clark
 * @ Modified time: 2025-05-29 16:47:19
 * @ Description: 2nd highest level component. Mainly imports fontawesome icons.
 */

import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router'
import configureStore from './config/configureStore'
import { Provider } from 'react-redux'
import Routes from './Routes'
import DealSauceAIBanner from './components/DealSauceAIBanner'
import ScrollToTop from './utils/ScrollToTop'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useApolloClient } from "@apollo/client/react";
import AnalyticsLoader from '@/layout-components/AnalyticsLoader'
import CssBaseline from '@mui/material/CssBaseline'
import ColorModeProvider from './theme/ColorModeProvider'
import AppThemeProvider from './theme/AppThemeProvider'
// import Affiliate from '../Affiliate/affiliate'
// import CorpSignupPage from '../SignUp/corpSignupPage'

/////IMPORT FONTS/////

// Centralized FontAwesome icon management
import {
  initializeIconLibrarySync,
  getTotalIconCount,
} from '@/utils/icons'

// Initialize the icon library
initializeIconLibrarySync()

const store = configureStore()

import { Helmet, HelmetProvider } from 'react-helmet-async'
const REFETCH_INTERVAL_MS = 10 * 60 * 1000 // 10 minutes

const App = () => {
  const client = useApolloClient()
  const lastFocusRef = React.useRef(Date.now())

  useEffect(() => {
    const onFocus = () => {
      const now = Date.now()
      if (now - lastFocusRef.current > REFETCH_INTERVAL_MS) {
        console.log(
          'Window focused, refetching all active queries (10 min threshold met)',
        )
        client.refetchQueries({ include: 'active'  })
        lastFocusRef.current = now
      }
    }
    window.addEventListener('focus', onFocus)
    return () => window.removeEventListener('focus', onFocus)
  }, [client])

  useEffect(() => {
    const removeLoomElement = () => {
      const loomElement = document.querySelector(
        '#shadow-host-companion',
      )
      if (loomElement) {
        loomElement.style.display = 'none'
      }
    }

    removeLoomElement()
  }, [])

  // useEffect(() => {
  //   if ('serviceWorker' in navigator) {
  //     navigator.serviceWorker.addEventListener(
  //       'controllerchange',
  //       () => {
  //         // Notify the user about the new version and ask for a refresh
  //         alert(
  //           'A new version is available. Please refresh the page.',
  //         )
  //       },
  //     )
  //   }
  // }, [])

  const helmetContext = {}

  return (
    <Provider store={store}>
      <HelmetProvider context={helmetContext}>
        <Helmet>
          {/* <link
            id="favicon"
            rel="shortcut icon"
            href="/images/LeftNavLogo.png"
            async
          /> */}
          <title id="titleId">
            Housefolios - Analyze, Manage and Sell Real Estate
          </title>
        </Helmet>
        <BrowserRouter>
          <AnalyticsLoader />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ScrollToTop>
              <DealSauceAIBanner />
              <ColorModeProvider>
                <AppThemeProvider>
                  <CssBaseline />
                  <Routes />
                </AppThemeProvider>
              </ColorModeProvider>
            </ScrollToTop>
          </LocalizationProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  )
}

export default App
